import { createFileRoute } from '@tanstack/react-router'
import MfaCode from '~/components/mfa'

export const Route = createFileRoute('/_pathlessLayout/mfa')({
  loader: (navigation) => {
    return navigation.location?.search || ''
  },
  component: MfaPage,
})

function MfaPage() {
  return <MfaCode />
}
